// import { defineComponent, toRef, unref, inject, computed } from 'vue'
// import { computed, defineComponent, inject, toRefs } from 'vue'
import { defineComponent, inject, toRefs } from 'vue'
import classes from '@/assets/styles/my-table.module.less'
export default defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    col: {
      type: Object,
      default: () => { }
    },
    collapseColumns: {
      type: Array,
      default: () => ([])
    }
  },
  setup (props) {
    const { collapseColumns } = toRefs(props)
    // const item = unref(toRef(props, 'item'))
    // const col = unref(toRef(props, 'col'))
    const slots = inject('slots')
    // const hoveredKrId = inject('hoveredKrId')
    // const getClass = (rowId) => computed(() => [classes.item, Number(hoveredKrId.value) === rowId && classes.hover].join(' '))
    return () => {
      const item = props.item
      const col = props.col
      // const text = computed(() => collapseColumns.value.includes(col.dataIndex) ? '' : item[col.dataIndex])
      // console.log(slots?.bodyCell?.({ text: item[col.dataIndex], record: item, column: col.dataIndex }))
      // return <div key={`${item.rowId}-${col.dataIndex}`} rowid={item.rowId} className={ getClass(item.rowId).value } bottomIndex={item.rowId} style={ col.rowSpan && col.rowSpan(item) && { 'grid-row-end': `span ${col.rowSpan(item)}` }}>
      return <div key={`${item.rowId}-${col.dataIndex}`} rowid={item.rowId} className={ classes.item } bottomIndex={item.rowId} rightIndex={ col.dataIndex } style={ col.rowSpan && col.rowSpan(item) && { 'grid-row-end': `span ${col.rowSpan(item)}` }}>
        <div className={classes.content}>
          {/* {slots.bodyCell?.({ text: text.value, record: item, column: col.dataIndex }) || text.value} */}
          {collapseColumns.value.includes(col.dataIndex) ? '' : slots.bodyCell?.({ text: item[col.dataIndex], record: item, column: col.dataIndex }) || item[col.dataIndex]}
          {/* {(col.dataIndex.split(':')).reduce((pre, cur) => pre[cur] || '-', item)} */}
        </div>
        {/* {col.dataIndex === 'krContent' && <div className={classes.bottom} ></div>} */}
        <div className={classes.bottom}></div>
        <div className={classes.right}></div>
      </div>
    }
  }
})
